module.exports = __webpack_public_path__ + "img/freightliner_thumbnail.09cc85de.png";